import PropTypes from "prop-types";
import classnames from "classnames";

import "./styles.scss";


function ButtonInput({children, className, outline, ...props}) {
    return <button className={classnames("ButtonInput", {"Outline": outline}, className)} {...props}>
        {children}
    </button>;
}

ButtonInput.propTypes = {
    outline: PropTypes.bool,
};

ButtonInput.defaultProps = {
    outline: false,
};

export default ButtonInput;
